// This file was auto-generated by querybuilder/Apollo and should not be edited.

import * as ExtendedFormFieldErrors from './ExtendedFormFieldErrors';
import * as LandlordDetailsType from './LandlordDetailsType';
import { LandlordLandlordDetailsFormFormSetInput } from './globalTypes';
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

import { LocLandlordInfoInput } from "./globalTypes";

// ====================================================
// GraphQL mutation operation: LocLandlordInfoMutation
// ====================================================

export interface LocLandlordInfoMutation_output_errors_extendedMessages {
  /**
   * A human-readable validation error.
   */
  message: string;
  /**
   * A machine-readable representation of the error.
   */
  code: string | null;
}

export interface LocLandlordInfoMutation_output_errors {
  /**
   * The camel-cased name of the input field, or '__all__' for non-field errors.
   */
  field: string;
  /**
   * A list of validation errors with extended metadata.
   */
  extendedMessages: LocLandlordInfoMutation_output_errors_extendedMessages[];
}

export interface LocLandlordInfoMutation_output_session_landlordDetails {
  /**
   * Usually the first line of the address, e.g. "150 Court Street"
   */
  primaryLine: string;
  /**
   * The city of the address, e.g. "Brooklyn".
   */
  city: string;
  /**
   * The zip code of the address, e.g. "11201" or "94107-2282".
   */
  zipCode: string;
  /**
   * The landlord's name.
   */
  name: string;
  /**
   * The landlord's email address.
   */
  email: string;
  /**
   * A U.S. phone number without parentheses or hyphens, e.g. "5551234567".
   */
  phoneNumber: string;
  /**
   * Whether the name and address was looked up automatically, or manually entered by the user.
   */
  isLookedUp: boolean;
  /**
   * The full mailing address of the user, as a single string. Note that this may
   * actually be populated even if individual address fields are empty; this
   * represents legacy data created before we split up addresses into individual fields.
   */
  address: string;
  state: string;
}

export interface LocLandlordInfoMutation_output_session {
  landlordDetails: LocLandlordInfoMutation_output_session_landlordDetails | null;
}

export interface LocLandlordInfoMutation_output {
  /**
   * A list of validation errors in the form, if any. If the form was valid, this list will be empty.
   */
  errors: LocLandlordInfoMutation_output_errors[];
  session: LocLandlordInfoMutation_output_session | null;
}

export interface LocLandlordInfoMutation {
  output: LocLandlordInfoMutation_output;
}

export interface LocLandlordInfoMutationVariables {
  input: LocLandlordInfoInput;
}

export const BlankLocLandlordInfoInput: LocLandlordInfoInput = {
  "useRecommended": false,
  "landlord": []
};


export const BlankLandlordLandlordDetailsFormFormSetInput: LandlordLandlordDetailsFormFormSetInput = {
  "name": "",
  "primaryLine": "",
  "city": "",
  "state": "",
  "zipCode": ""
};

export const LocLandlordInfoMutation = {
  // The following query was taken from LocLandlordInfoMutation.graphql.
  graphQL: `# This file was auto-generated by querybuilder, please do not edit it.
mutation LocLandlordInfoMutation($input: LocLandlordInfoInput!) {
  output: locLandlordInfo(input: $input) {
    errors { ...ExtendedFormFieldErrors },
    session {
      landlordDetails { ...LandlordDetailsType }
    }
  }
}
${ExtendedFormFieldErrors.graphQL}
${LandlordDetailsType.graphQL}`,
  name: "LocLandlordInfoMutation",
  fetch(fetchGraphQL: (query: string, args?: any) => Promise<any>, args: LocLandlordInfoMutationVariables): Promise<LocLandlordInfoMutation> {
    return fetchGraphQL(LocLandlordInfoMutation.graphQL, args);
  },
  blankInput: BlankLocLandlordInfoInput,
};

export const fetchLocLandlordInfoMutation = LocLandlordInfoMutation.fetch;